module.exports = __webpack_public_path__ + "static/media/bg-hearts.7c6c6045.png";